<template>
  <Modal class-name="vertical-center-modal"
         v-model="isAdmin"
         width="45%"
         title="绑定微信管理员">
    <div class="form-wrapper">
      <div class="explain">
        <span class="explain-title">说明：</span>
        <span>绑定微信管理员，可以用管理员微信关注“守兔票务”公众号，从公众号菜单“第三方入口”进入管理台中心，查看肯德基订单和公众号推广收入。</span>
      </div>
      <div class="padding-tb-10 margin-top-50">
        <div class="part-div">
          <el-row>
            <el-col :span="11">
              <div class="img-wrap img-left">
                <div class="img-box">
                  <div class="img-padding">
                    <div class="img-border">
                      <div id="qrcode" ref="qrcode"></div>
                      <div class="top-left"></div>
                      <div class="top-right"></div>
                      <div class="bottom-left"></div>
                      <div class="bottom-right"></div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="13">
              <div style="margin: 60px 20px;">
                <div>
                  <span class="step-btn">步骤一</span>
                </div>
                <div class="step-tip">请用管理员微信扫一扫二维码</div>
                <div class="step-tip">平台ID:<span>{{ platformUuid }}</span></div>
                <div class="step-tip">平台密码:<span>{{ secret }}</span></div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="padding-tb-10">
        <div class="part-div">
          <el-row>
            <el-col :span="13">
              <div style="margin: 60px 35px;">
                <div>
                  <span class="step-btn">步骤二</span>
                </div>
                <div class="step-tip">
                  <div>扫码打开管理员绑定链接</div>
                  <div>填写信息后，点击“确认绑定”按钮，完成绑定</div>
                </div>
              </div>
            </el-col>
            <el-col :span="11">
              <div class="img-wrap img-right">
                <img style="width: 100%" src="../../assets/img/kfc/steps_2_1.png" alt="">
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="padding-tb-10">
        <div class="part-div">
          <el-row>
            <el-col :span="11">
              <div class="img-wrap img-left">
                <img style="width: 100%" src="../../assets/img/kfc/steps_3.png" alt="">
              </div>
              <div style="text-align: center;color: #76BAFC;height: 50px;padding-top: 10px;">3、我的收益页面</div>
            </el-col>
            <el-col :span="13">
              <div style="margin: 60px 20px 0 20px">
                <div>
                  <span class="step-btn">步骤三</span>
                </div>
                <div class="step-tip">
                  绑定完成后，管理员微信关注“守兔票务”公众号，点击菜单“第三方入口”就可以查看肯德基订单和推广收益啦~
                </div>
                <div style="position: absolute;bottom: 50px;">
                  <img style="width: 75%" src="../../assets/img/kfc/steps_3_1.png" alt="">
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
  import QRCode from 'qrcodejs2';
  import { getPlatformUuidKfc } from '@/utils/auth'
  import { Modal } from 'view-design'
  import kfc from '@/javaApi/kfc/kfc'
  const kfcModel = new kfc()
  export default {
    name: "Admin",
    components: {
      Modal
    },
    props: {},
    created() {},
    data: function () {
      return {
        loading: false,
        platformUuid: getPlatformUuidKfc(),
        secret: '',
        isAdmin: false,
        bindAdminLink : process.env.VUE_APP_KFC_AUTH_URL + 'movie/index/platform/bind?platformUUID='+ process.env.VUE_APP_MOVIE_PLATFORMUUID
      }
    },
    mounted:function(){
    },
    methods: {
      init: function () {
        //获取绑定管理员密码
        this.getSecret();
        //取得容器
        var e = document.getElementById("qrcode");
        var child = e.lastElementChild;
        while (child) {
            e.removeChild(child);
            child = e.lastElementChild;
        }
        this.isAdmin = true;
        setTimeout(() => {
          this.$nextTick(() => {
            this.qrcode();
          });
        }, 100);
      },
      //获取平台id和密码
      getSecret(){
        var that = this;
        that.loading = true;
        kfcModel.getSecret({platformUuid: this.platformUuid}).then((response) =>{
          console.log(response)
          that.loading = false;
          if(response.data.code == 200) {
            that.secret = response.data.data.secret
          }
        }).catch(error=>{
          that.loading = false;
          console.log(error)
        })
      },
      //生成二维码
      qrcode(){
        var maxWidth = this.$refs.qrcode.clientWidth
        let qrcode = new QRCode(this.$refs.qrcode, {
          text: this.bindAdminLink,
          width: maxWidth,
          height: maxWidth,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
        })
      }
    }
  }
</script>

<style scoped>
  .color-666{
    color: #666666;
  }
  .color-222{
    color: #222222;
  }
  .font-weight-bold{
    font-weight: bold;
  }
  .text-right{
    text-align: right;
  }
  .padding-5{
    padding: 5px;
  }
  .padding-tb-10{
    padding: 10px 0
  }
  .margin-top-50{
    margin-top: 50px;
  }
  .normal-font {
    color: #D63036;;
    font-size: 14px;
  }
  .form-wrapper{
    max-height: 500px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .form-wrapper::-webkit-scrollbar {
    width: 0;
  }
  .form-wrapper .explain{
    font-family: Alibaba-PuHuiTi-R;
    font-size: 13px;
    color: #D63036;
    line-height: 20px;
    position: fixed;
    background: #FFFFFF;
    z-index: 999;
    width: 43%;
    padding-bottom: 10px;
  }
  .form-wrapper .explain .explain-title{
    font-family: Alibaba-PuHuiTi-M;
  }
  .form-wrapper .part-div{
    background: #FAFAFA;
    border-radius: 4px;
  }
  .form-wrapper .part-div .img-wrap{
    margin: 20px 20px 0 20px;
  }
  .form-wrapper .part-div .img-left{
    margin: 20px 20px 0 35px;
  }
  .form-wrapper .part-div .img-right{
    margin: 20px 35px 0 20px;
  }
  .form-wrapper .part-div .img-wrap .img-box{
    background: #FFFFFF;
    border-radius: 25px 25px 0 0;
    border: 1px solid #D63036;
    border-bottom: none;
  }
  .form-wrapper .part-div .img-wrap .img-box .img-padding{
    padding: 30px;
  }
  .form-wrapper .part-div .img-wrap .img-box .img-padding .img-border{
    background: #FFFFFF;
    border: 1px solid rgba(255,134,34,0.10);
    position: relative;
    padding: 6px;
  }
  .form-wrapper .part-div .img-wrap .img-box .img-padding .img-border img{
    width: 100% !important;
  }
  .form-wrapper .part-div .img-wrap .img-box .img-padding .img-border .top-left, .top-right, .bottom-left, .bottom-right {
    position: absolute;
    width: 10px;
    height: 10px;
    z-index: 1;
  }
  .form-wrapper .part-div .img-wrap .img-box .img-padding .img-border .top-left {
    top: -1px;
    left: -1px;
    border-top: 1px solid #D63036;
    border-left: 1px solid #D63036;
  }
  .form-wrapper .part-div .img-wrap .img-box .img-padding .img-border .top-right {
    top: -1px;
    right: -1px;
    border-top: 1px solid #D63036;
    border-right: 1px solid #D63036;
  }

  .form-wrapper .part-div .img-wrap .img-box .img-padding .img-border .bottom-left {
    left: -1px;
    bottom: -1px;
    border-left: 1px solid #D63036;
    border-bottom: 1px solid #D63036;
  }

  .form-wrapper .part-div .img-wrap .img-box .img-padding .img-border .bottom-right {
    right: -1px;
    bottom: -1px;
    border-right: 1px solid #D63036;
    border-bottom: 1px solid #D63036;
  }
  .form-wrapper .part-div .step-btn{
    background-image: linear-gradient(90deg, #FFBB47 6%, #D63036 89%, #D63036 89%);
    border-radius: 17px;
    color: #FFFFFF;
    font-family: Alibaba-PuHuiTi-R;
    font-size: 16px;
    padding: 3px 15px;
  }
  .form-wrapper .part-div .step-tip{
    font-family: Alibaba-PuHuiTi-M;
    font-size: 14px;
    color: #222222;
    padding-top: 20px;
  }
  .step-tip span{
    color: #D63036;
  }
  >>> .ivu-modal-body {
    padding: 16px;
  }
  >>> .ivu-modal-content{
    border-radius: 0;
  }
  >>> .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  >>> .vertical-center-modal .ivu-modal {
    top: 0;
  }
  >>> .ivu-modal-footer {
      border-top: none;
      padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/kfc/Admin.vue